export default __webpack_public_path__ + "static/media/GOOGLE_BIGQUERY.f819d737.jpg";